import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import QuickNavigation from "../components/common/quick-navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCube, faPlane } from "@fortawesome/free-solid-svg-icons";
import AirframeTemplateUploadCard from "../components/assets-management/templates/AirframeTemplateUploadCard";
import { useHasPermission } from "../hooks/useHasPermission";

const Assets: React.FC = () => {
  const canManageAssemblies = useHasPermission("assets-assemblies", "read");
  const canManageAirframes = useHasPermission("assets-airframes", "read");
  const canUseBulkTemplateUpload = useHasPermission(
    "assets-bulk-template-upload",
    "read"
  );
  const canAccessBulkTemplateTile = canUseBulkTemplateUpload;

  return (
    <Box sx={{ width: "100%", mt: 3 }}>
      <Typography
        variant="h6"
        align="center"
        fontWeight={700}
        color="#fff"
        sx={{ mb: 3 }}
      >
        Quick Navigation
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {canManageAssemblies && (
            <Grid size={{ xs: 12, lg: 4 }} sx={{ minWidth: 350 }}>
              <QuickNavigation
                icon={<FontAwesomeIcon icon={faCube} />}
                actions={[
                  {
                    label: "Add/Edit Assemblies",
                    route: "/assets/manage-component",
                  },
                ]}
                title="Manage Assemblies"
                description="Add/Edit Assemblies like APU, Landing Gear"
              />
            </Grid>
        )}

        {canManageAssemblies && (
            <Grid size={{ xs: 12, lg: 4 }} sx={{ minWidth: 350 }}>
              <QuickNavigation
                icon={<FontAwesomeIcon icon={faCube} />}
                actions={[
                  {
                    label: "Add/Edit Sub-Assemblies",
                    route: "/assets/manage-sub-assembly",
                  },
                ]}
                title="Manage Sub-Assemblies"
                description="Add/Edit Landing Gear Sub-Assemblies like RMLG, LMLG, NLG"
              />
            </Grid>
        )}

        {canManageAirframes && (
            <Grid size={{ xs: 12, lg: 4 }} sx={{ minWidth: 350 }}>
              <QuickNavigation
                icon={<FontAwesomeIcon icon={faPlane} />}
                actions={[
                  {
                    label: "Add/Edit Airframe",
                    route: "/assets/manage-airframe",
                  },
                ]}
                title="Manage Airframes"
                description="Add/Edit Airframes and their Components"
              />
            </Grid>
        )}

        {canAccessBulkTemplateTile && <AirframeTemplateUploadCard />}
      </Grid>
    </Box>
  );
};

export default Assets;